import styled from 'styled-components';
import { TabsRootProps } from './Tabs.types';

export const StyledTabs = styled.div<TabsRootProps>`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  width: ${({ width }) => width || '100%'};
  height: 44px;
  padding: 0 4px;
  background: ${({ theme }) => theme[theme.color].Tabs.background};
  border: 1px solid ${({ theme }) => theme[theme.color].Tabs.border};
  border-radius: 100px;
`;
